import moment from 'moment';
import HelperMixin from '../../Shared/HelperMixin.vue';

const STATUS = [
    { value: 0, label: 'قيد الطريق (غير المغلقة)' },
    { value: 1, label: 'مسودة' },
    { value: 2, label: 'مؤكَّد' },
    { value: 3, label: 'وصل جزئياً' },
    { value: 4, label: 'وصل بالكامل' },
    { value: 5, label: 'ملغى' },
];

export default {
    name: 'SupplyOrders',
    mixins: [HelperMixin],

    async created() {
        await this.CheckLoginStatus();
        // نفس حارس الخادم: أمر التوريد قرار وزاري.
        if (!this.loginDetails || !this.hasAdministratorOperationalAccessUi()) {
            this.$helper.ShowMessage('error', 'غير مصرح', 'أوامر التوريد متاحة لإدارة الصيدلة ومدير النظام.');
            this.href('/Home');
            return;
        }
        this.loadLookups();
        this.GetInfo();
    },

    filters: {
        momentDate(date) {
            if (!date) return '—';
            return moment(date).format('DD/MM/YYYY');
        },
    },

    data() {
        return {
            statusOptions: STATUS,
            filters: { status: 0, supplierId: null },

            Info: [],
            totals: null,
            warnDays: 7,
            loading: false,

            suppliers: [],
            stockings: [],
            formularyItems: [],
            loadingItems: false,
            // تنظيم توريد الأدوية التخصصية: قصر قائمة الاختيار عليها
            specializedOnly: false,
            specializedLabel: null,

            createDialog: false,
            saving: false,
            form: {
                id: null,
                supplierCustomersId: null,
                targetStockingId: null,
                orderDate: moment().format('YYYY-MM-DD'),
                expectedArrivalOn: '',
                note: '',
                lines: [],
            },

            detailDialog: false,
            detail: null,
            detailLoading: false,

            arrivalDialog: false,
            arrivalLines: [],
            arrivalSaving: false,
        };
    },

    computed: {
        totalOrdered() {
            return (this.form.lines || []).reduce((s, l) => s + Number(l.quantityOrdered || 0), 0);
        },
    },

    methods: {
        /* ── القائمة ──────────────────────────────────────────── */

        GetInfo() {
            this.loading = true;
            this.$http.GetSupplyOrdersPipeline(this.filters)
                .then((res) => {
                    this.loading = false;
                    const d = (res && res.data) || {};
                    this.Info = d.info || [];
                    this.totals = d.totals || null;
                    this.warnDays = d.warnDays || 7;
                })
                .catch((err) => {
                    this.loading = false;
                    this.Info = [];
                    this.apiError(err, 'تعذّر تحميل أوامر التوريد.');
                });
        },

        apiError(err, fallback) {
            const msg = err && err.response && err.response.data ? err.response.data : fallback;
            this.$helper.ShowMessage('error', 'خطأ', msg);
        },

        loadLookups() {
            this.$http.GetAllSuppliers()
                .then((r) => { this.suppliers = (r.data && r.data.info) || []; })
                .catch(() => { this.suppliers = []; });
            // مخازن الوزارة فقط: أمر التوريد يرد إلى الإمداد لا إلى مخزن مرفق.
            this.$http.GetAllStocking()
                .then((r) => {
                    const all = (r.data && r.data.info) || [];
                    this.stockings = all.filter((x) => !x.branchesId && x.status === 1);
                })
                .catch(() => { this.stockings = []; });
        },

        searchFormularyItems(term) {
            this.loadingItems = true;
            this.$http.GetPharmacyReportLookups(term, this.specializedOnly)
                .then((r) => {
                    this.loadingItems = false;
                    this.specializedLabel = (r.data && r.data.specializedLabel) || null;
                    const products = (r.data && r.data.products) || [];
                    // أمر التوريد يُكتب على الصنف النمطي — تُطوى البدائل التجارية إليه.
                    const map = new Map();
                    products.forEach((p) => {
                        if (!p.formularyItemId) return;
                        if (!map.has(p.formularyItemId)) {
                            map.set(p.formularyItemId, {
                                id: p.formularyItemId,
                                name: p.scientificName || p.name,
                                nationalCode: p.nationalCode,
                                isSpecialized: !!p.isSpecialized,
                            });
                        }
                    });
                    this.formularyItems = Array.from(map.values());
                })
                .catch(() => { this.loadingItems = false; this.formularyItems = []; });
        },

        /* ── مؤشرات الوصول ────────────────────────────────────── */

        arrivalClass(row) {
            if (row.isOverdue) return 'text-danger fw-semibold';
            if (row.isArrivingSoon) return 'text-warning fw-semibold';
            if (row.hasNoEta) return 'text-muted';
            return '';
        },

        arrivalNote(row) {
            if (row.hasNoEta) return 'بلا موعد متوقع';
            if (row.isOverdue) return `تأخّر ${Math.abs(row.daysToArrival)} يوم`;
            if (row.daysToArrival === 0) return 'متوقع اليوم';
            if (row.isArrivingSoon) return `خلال ${row.daysToArrival} يوم`;
            return `بعد ${row.daysToArrival} يوم`;
        },

        statusBadgeClass(status) {
            if (status === 4) return 'bg-label-success';
            if (status === 3) return 'bg-label-info';
            if (status === 2) return 'bg-label-primary';
            if (status === 5) return 'bg-label-danger';
            return 'bg-label-secondary';
        },

        /* ── الإنشاء ──────────────────────────────────────────── */

        openCreate() {
            this.form = {
                id: null,
                supplierCustomersId: null,
                targetStockingId: null,
                orderDate: moment().format('YYYY-MM-DD'),
                expectedArrivalOn: '',
                note: '',
                lines: [],
            };
            this.searchFormularyItems('');
            this.createDialog = true;
        },

        toggleSpecialized() {
            this.specializedOnly = !this.specializedOnly;
            this.searchFormularyItems('');
        },

        addLine() {
            this.form.lines.push({ nationalFormularyItemsId: null, quantityOrdered: 1, note: '' });
        },

        removeLine(i) {
            this.form.lines.splice(i, 1);
        },

        submitForm() {
            if (!this.form.supplierCustomersId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر المورّد.');
                return;
            }
            // سنة من رقمين تصير 0028 في حقل التاريخ — تُرفض قبل الإرسال.
            const dateProblem = this.expiryDateProblem(this.form.orderDate, null, 'تاريخ الأمر')
                || this.expiryDateProblem(this.form.expectedArrivalOn, null, 'تاريخ الوصول المتوقع');
            if (dateProblem) {
                this.$helper.ShowMessage('warning', 'تنبيه', dateProblem);
                return;
            }
            const lines = (this.form.lines || [])
                .filter((l) => l.nationalFormularyItemsId && Number(l.quantityOrdered) > 0);
            if (!lines.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'أضف صنفاً واحداً على الأقل بكمية صحيحة.');
                return;
            }

            const body = {
                supplierCustomersId: Number(this.form.supplierCustomersId),
                targetStockingId: this.form.targetStockingId ? Number(this.form.targetStockingId) : null,
                orderDate: this.form.orderDate || null,
                expectedArrivalOn: this.form.expectedArrivalOn || null,
                note: this.form.note || null,
                lines: lines.map((l) => ({
                    nationalFormularyItemsId: Number(l.nationalFormularyItemsId),
                    quantityOrdered: Number(l.quantityOrdered),
                    note: l.note || null,
                })),
            };

            this.saving = true;
            const action = this.form.id
                ? this.$http.UpdateSupplyOrder(this.form.id, body)
                : this.$http.CreateSupplyOrder(body);

            action.then((res) => {
                this.saving = false;
                this.createDialog = false;
                this.$helper.ShowMessage('success', 'تم', (res.data && res.data.message) || 'تم الحفظ.');
                this.GetInfo();
            }).catch((err) => {
                this.saving = false;
                this.apiError(err, 'تعذّر حفظ أمر التوريد.');
            });
        },

        /* ── التفاصيل والإجراءات ──────────────────────────────── */

        openDetail(row) {
            this.detail = null;
            this.detailLoading = true;
            this.detailDialog = true;
            this.$http.GetSupplyOrder(row.id)
                .then((res) => {
                    this.detailLoading = false;
                    this.detail = (res.data && res.data.info) || null;
                })
                .catch((err) => {
                    this.detailLoading = false;
                    this.apiError(err, 'تعذّر تحميل التفاصيل.');
                });
        },

        confirmOrder(row) {
            this.$confirm('التأكيد يُدخل الأمر إلى قائمة «قيد الطريق» ويمنع تعديله. متابعة؟', 'تأكيد أمر التوريد', {
                confirmButtonText: 'تأكيد', cancelButtonText: 'تراجع', type: 'warning',
            }).then(() => {
                this.$http.ConfirmSupplyOrder(row.id)
                    .then((res) => {
                        this.$helper.ShowMessage('success', 'تم', (res.data && res.data.message) || 'تم التأكيد.');
                        this.detailDialog = false;
                        this.GetInfo();
                    })
                    .catch((err) => this.apiError(err, 'تعذّر التأكيد.'));
            }).catch(() => { });
        },

        cancelOrder(row) {
            this.$prompt('سبب الإلغاء', 'إلغاء أمر التوريد', {
                confirmButtonText: 'إلغاء الأمر', cancelButtonText: 'تراجع', inputType: 'textarea',
            }).then(({ value }) => {
                this.$http.CancelSupplyOrder(row.id, { Reason: value || null })
                    .then((res) => {
                        this.$helper.ShowMessage('success', 'تم', (res.data && res.data.message) || 'تم الإلغاء.');
                        this.detailDialog = false;
                        this.GetInfo();
                    })
                    .catch((err) => this.apiError(err, 'تعذّر الإلغاء.'));
            }).catch(() => { });
        },

        openArrival() {
            if (!this.detail) return;
            // المتبقي هو الافتراضي: الحالة الغالبة وصول ما تبقّى.
            this.arrivalLines = (this.detail.lines || []).map((l) => ({
                nationalFormularyItemsId: l.nationalFormularyItemsId,
                scientificName: l.scientificName,
                quantityOrdered: l.quantityOrdered,
                quantityReceived: l.quantityReceived,
                pending: l.quantityPending,
                arriving: l.quantityPending,
            }));
            this.arrivalDialog = true;
        },

        submitArrival() {
            const payload = (this.arrivalLines || [])
                .filter((l) => Number(l.arriving) > 0)
                .map((l) => ({
                    nationalFormularyItemsId: l.nationalFormularyItemsId,
                    quantityOrdered: Number(l.arriving),
                }));
            if (!payload.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'حدّد الكميات الواصلة.');
                return;
            }

            this.arrivalSaving = true;
            this.$http.RecordSupplyArrival(this.detail.id, payload)
                .then((res) => {
                    this.arrivalSaving = false;
                    this.arrivalDialog = false;
                    this.detailDialog = false;
                    this.$helper.ShowMessage('success', 'تم', (res.data && res.data.message) || 'تم التسجيل.');
                    this.GetInfo();
                })
                .catch((err) => {
                    this.arrivalSaving = false;
                    this.apiError(err, 'تعذّر تسجيل الوصول.');
                });
        },
    },
};
